<template>
    <div class="main">
        <admin-navigation></admin-navigation>
        <div class="content-area">
            <div class="page-header">
                <div class="page-details">
                    <h2>Overview Report</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/overview-report'" class="current">Overview Report</router-link>
                        </li>
                    </ul>
                </div>
                <div class="actions">
                    <button @click="exportReport" class="btn btn-primary"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 15L21 19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21L5 21C4.46956 21 3.96086 20.7893 3.58578 20.4142C3.21071 20.0391 3 19.5304 3 19L3 15M7 10L12 15M12 15L17 10M12 15L12 3" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Export Report</button>
                </div>
            </div>
            <div>
                <div class="searchbar">
                    <form id="getFilterDataform" action="#">
                        <div class="filters">
                            <div class="filter">
                                <div class="filter__header">
                                    <VueDatePicker v-model="date" range format="DD/MM/YYYY" :color="admin_color"><i class="fa fa-calendar-week" /></VueDatePicker>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Type</span><span class="filter__value"><span class="class-all">All</span></span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false">
                                        <input type="checkbox" name="static_qr" id="static_qr" value="1" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">QR</label>
                                    </div>
                                    <div class="input-checkbox" data-active="false">
                                        <input type="checkbox" name="gps_checkin" id="gps_checkin" value="1" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">Remote</label>
                                    </div>
                                    <div class="input-checkbox" data-active="false">
                                        <input type="checkbox" name="qr_card" id="qr_card" value="1" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">Kiosk</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Location</span><span class="filter__value">All</span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" v-for="location in locations" @click="getFilterData">
                                        <input type="checkbox" name="location_id[]" :value="location.id" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">{{location.name}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Tags</span><span class="filter__value">All</span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" v-for="tag in tags">
                                        <input type="checkbox" name="tag_id[]" :value="tag.id" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">{{ tag.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <button type="button" class="btn filter-button" @click="getFilterData">Filter</button>
                            <div class="filter--reset" @click="resetFilter">
                                <a href="#"> Reset Filter</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="section no-bg mt-4">
                <div class="custom-table">
                    
                    <div class="custom-table__row">
                        <div class="custom-table__entry"><label for="">Users</label></div>
                        <div class="custom-table__overflow">
                            <div class="custom-table__entry time" v-for="date in dates"><label for="">{{ date }}</label></div>
                        </div>
                    </div>

                    <div class="custom-table__row" v-for="employees in employees">
                        <div class="custom-table__entry">
                            <div class="custom-table__user">
                                <h5>{{ employees.full_name }}</h5>
                                <p>{{ employees.department }} | {{ employees.phone }}</p>
                                <span>{{ employees.hrs }}</span>
                            </div>
                        </div>
                        <div class="custom-table__overflow">

                            <div class="custom-table__entry" v-for="attendance in employees.data">
                                <div class="custom-table__time">
                                    <div class="wrapper">
                                        <div class="checkin">
                                            <h5>{{ attendance.check_in }}</h5>
                                            <p>{{ attendance.location_check_in }}</p>
                                        </div>
                                        <div class="checkout">
                                            <h5>{{ attendance.check_out }}</h5>
                                            <p>{{ attendance.location_check_out }}</p>
                                        </div>
                                    </div>
                                    <span>{{ attendance.hrs }}</span>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dates: [],
            employees: [10],
            locations: {},
            tags: {},
            date_to: null,
            date_from: null,
            date: new Date(),
        }
    },
    created() {
        this.getLocations();
        this.getTags();
    },
    mounted() {
        this.getAttendence();
    },
    updated() {
        this.fireScroll();
    },
    methods: {
        getAttendence(obj = "") {
            axios.get("/api/admin/overview-report?" + obj).then(response => {
                this.dates = response.data.data.dates;
                this.employees = response.data.data.employees;
                this.fireScroll();
            });
        },
        fireScroll() {
            let scrollerBlocks = document.querySelectorAll('.custom-table__overflow');
            let allelements = document.getElementsByClassName('custom-table__overflow');
 
            scrollerBlocks.forEach(ele => {
                ele.style.cursor = 'grab';
 
                let pos = { top: 0, left: 0, x: 0, y: 0 };
 
                let mouseDownHandler = function(e) {
                    ele.style.cursor = 'grabbing';
                    // ele.style.userSelect = 'none';
 
                    pos = {
                        left: ele.scrollLeft,
                        top: ele.scrollTop,
                        // Get the current mouse position
                        x: e.clientX,
                        y: e.clientY,
                    };
 
                    document.addEventListener('mousemove', mouseMoveHandler);
                    document.addEventListener('mouseup', mouseUpHandler);
                };
 
                let mouseMoveHandler = function(e) {
                    // How far the mouse has been moved
                    let dx = e.clientX - pos.x;
                    let dy = e.clientY - pos.y;
 
                    // Scroll the element
                    $('.custom-table__overflow').scrollLeft(pos.left - dx)
                };
 
                let mouseUpHandler = function() {
                    ele.style.cursor = 'grab';
                    ele.style.removeProperty('user-select');
 
                    document.removeEventListener('mousemove', mouseMoveHandler);
                    document.removeEventListener('mouseup', mouseUpHandler);
                };
 
                // Attach the handler
                ele.addEventListener('mousedown', mouseDownHandler);
 
                for (var i = 0; i < allelements.length; i++) {
                    allelements[i].addEventListener('mousedown', mouseDownHandler);
                }            
            });
            
        },
        getFilterData() {
            setTimeout(() => {
                var formData = $("#getFilterDataform").serializeArray();
                var token = { "name": "token", "value": localStorage.getItem("admin_auth") };
                formData.push(token);
                if(this.date.start)
                {
                    formData.push({ "name": "date_from", "value": this.date.start });
                }
                if(this.date.end)
                {
                    formData.push({ "name": "date_to", "value": this.date.end });
                }

                this.getAttendence($.param(formData));
            }, 500);

        },
        getLocations() {
            axios.get("/api/admin/locations").then(response => {
                this.locations = response.data.data.records;
                if (Object.keys(response.data.data.records).length > 0) {
                    this.emptyLocations = false;
                } else {
                    this.emptyLocations = true;
                }
            });
        },
        getTags() {
            axios.get("/api/admin/tags").then(response => {
                this.tags = response.data.data;
                if (Object.keys(response.data.data).length > 0) {
                    this.emptyTags = false;
                } else {
                    this.emptyTags = true;
                }
            });
        },
        resetFilter() {
            
            $("#getFilterDataform")[0].reset();
            this.getAttendence();
        },
        exportReport() {
            var params = $("#getFilterDataform").serializeArray();
            var token = { "name": "token", "value": localStorage.getItem("admin_auth") };
            params.push(token);

            if(this.date.start) {
                params.push({ "name": "date_from", "value": this.date.start });
            }
            if(this.date.end) {
                params.push({ "name": "date_to", "value": this.date.end });
            }

            window.open("/api/admin/export-overview-report?" + $.param(params));
        }
    }
}

</script>
